import { VerificationManager } from "../VerificationManager";
import { ApiClientFactory } from "./clients";

export class VerificationManagerFactory {
  private readonly apiClientFactory: ApiClientFactory;

  constructor(baseUrl: string) {
    this.apiClientFactory = new ApiClientFactory(
      `${baseUrl}/api/v1/verification`
    );
  }

  createVerificationManager(): VerificationManager {
    return new VerificationManager(this.apiClientFactory.createApiClient());
  }
}
